<template>

    <div>
        <app-page-header></app-page-header>
        <v-container grid-list-xl>
            <!-- kriterij iskanja -->
            <v-layout row wrap align-left justify-space-around fill-height>
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-card>
                        <v-card-title>
                            <span class="subtitle-1"><v-icon left>mdi-filter</v-icon> Kriterij iskanja</span>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="card1 = !card1">
                                <v-icon>{{ card1 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-divider v-show="card1"></v-divider>
                        <v-card-text v-show="card1">
                            
                            <!-- obdobje plačila -->
                            <v-container grid-list-xl text-x-center align-center class="container--filters">
                                <v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs8 md4 align-content-center>
                                        <v-subheader class="pt-7 pl-0"><strong>Obdobje plačila (od - do)</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md4 align-content-center>
                                        <!-- začetni datum -->
                                        <v-menu
                                            ref="payment_start_date_menu"
                                            :close-on-content-click="false"
                                            v-model="payment_start_date_menu"
                                            :nudge-right="40"
                                            :return-value.sync="payment_start_date"
                                            
                                            transition="scale-transition"
                                            offset-y
                                            
                                            min-width="290px"
                                            >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                v-on="on"
                                                    v-model="payment_start_date_formatted"
                                                    label="Datum od"
                                                    prepend-icon="mdi-calendar-today"
                                                    readonly
                                                    clearable
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker color="secondary" @input="dateMenuSave('payment_start_date')" v-model="payment_start_date" no-title scrollable locale="sl-si">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs12 md4 align-content-center>
                                        <!-- končni datum -->
                                        <v-menu
                                            ref="payment_end_date_menu"
                                            :close-on-content-click="false"
                                            v-model="payment_end_date_menu"
                                            :nudge-right="40"
                                            :return-value.sync="payment_end_date"
                                            
                                            transition="scale-transition"
                                            offset-y
                                            
                                            min-width="290px"
                                            >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                v-on="on"
                                                    v-model="payment_end_date_formatted"
                                                    label="Datum do"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    clearable
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker color="secondary" @input="dateMenuSave('payment_end_date')" v-model="payment_end_date" no-title scrollable locale="sl-si">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <v-container grid-list-xl text-x-center align-center class="container--filters">
                                <!-- leto članarine -->
                                <v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-7 pl-0"><strong>Izberi leto za plačilo</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-select
                                            :items="years"
                                            label="Izberi leto"
                                            v-model="selectedMembershipFeePaymentYears"
                                            persistent-hint
                                            clearable
                                            multiple
                                            chips
                                            deletable-chips
                                            prepend-icon="mdi-bookmark"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>

                            <v-container grid-list-xl text-x-center align-cente class="container--filters">
                                <!-- leto članarine -->
                                <v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-7 pl-0"><strong>Izberi tip članarine</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-select
                                            :items="membershipFees"
                                            label="Izberi tip članarine"
                                            v-model="selectedMembershipFees"
                                            persistent-hint
                                            clearable
                                            multiple
                                            chips
                                            deletable-chips
                                            prepend-icon="mdi-bookmark"
                                            item-value="id"
                                            item-text="name"
                                            return-object
                                            dense
                                            no-data-text="Ni podatkov za prikaz"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>

                            <!-- plačnik -->
                            <v-container grid-list-xl text-x-center align-center class="container--filters">
                                <v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-7 pl-0"><strong>Naziv plačnika</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-text-field
                                        v-model="payer"
                                        label="Vpiši ime plačnika"
                                        prepend-icon="mdi-pencil"
                                        @keyup.esc="clearPayer"
                                        @keyup.enter="search"
                                        clearable
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            
                            <!-- član -->
                            <v-container grid-list-xl text-x-center align-center class="container--filters">
                                <v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-7 pl-0"><strong>Naziv člana</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-text-field
                                        v-model="member"
                                        label="Vpiši ime plačnika"
                                        prepend-icon="mdi-pencil"
                                        @keyup.esc="clearMember"
                                        @keyup.enter="search"
                                        clearable
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>

                            <!-- št. računa -->
                            <v-container grid-list-xl text-x-center align-center class="container--filters">
                                <v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-7 pl-0"><strong>Številka plačila</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-text-field
                                        v-model="invoice_nr"
                                        label="Vpiši številko računa"
                                        prepend-icon="mdi-pencil"
                                        @keyup.esc="clearInvoiceNr"
                                        @keyup.enter="search"
                                        clearable
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <!-- znesek pobranih članarin -->
                            <v-container grid-list-xl text-x-center align-center class="container--filters">
                                <v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-7 pl-0"><strong>Znesek pobranih članarin</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-text-field
                                        v-model="total_amount"
                                        label="Skupni znesek pobranih članarin"
                                        prepend-icon="mdi-cash"
                                        @keyup.esc="clearInvoiceNr"
                                        @keyup.enter="search"
                                        readonly
                                        filled
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>

                        </v-card-text>

                        <v-divider v-if="card1">
                        </v-divider>
                        <span v-if="card1">
                            <v-card-text v-if="$vuetify.breakpoint.xsOnly">
                            <v-btn   @click="search()" color="secondary" dark  block outlined style=""><v-icon left>mdi-magnify</v-icon>Prikaz rezultatov&nbsp;</v-btn><br>
                            <v-btn v-if="checkApplicationPermissions(['sobec-export-membership-fee-payments'])"   @click="exportData()" color="secondary" dark  block outlined style=""><v-icon left>mdi-export</v-icon>Izvoz&nbsp;</v-btn>
                            </v-card-text>
                            <v-card-text v-else>
                                <v-btn  @click="search()" color="secondary" dark text><v-icon left>mdi-magnify</v-icon>Prikaz rezultatov&nbsp;</v-btn>
                                <v-btn v-if="checkApplicationPermissions(['sobec-export-membership-fee-payments'])"  @click="exportData()" color="secondary" dark text><v-icon left>mdi-export</v-icon>Izvoz&nbsp;</v-btn>
                            </v-card-text>
                        </span>
                    </v-card>
                </v-flex>
            </v-layout>
            <br>
            <invoices-data-table
            :settings="dataTableSettings"
            :queryParameters="queryParameters"
            ></invoices-data-table> 

            <data-table-toggle-columns
            :dataTableId="dataTableSettings.id"
            :columns="dataTableSettings.headers"
            :dataTableColumnsMenuId="dataTableSettings.eventBus.toggleColumnsId"

            ></data-table-toggle-columns>
        </v-container>
    </div>
</template>

<script>
import { EventBus } from '@/main.js'
import { getCurrentDate, getCurrentTime, formatDate, getUserApplicationRole, getUserApplicationPermissions, checkPermissions } from '@/helpers/utilities'
const InvoicesDataTable = () => import('@/components/InvoicesDataTable.vue')
const DataTableToggleColumns = () => import('@/components/DataTableToggleColumns.vue')
import { isMobileDevice } from '@/helpers/utilities.js'
import { addExportToQueue } from '@/helpers/services.js'



export default 
{
    components: {
        InvoicesDataTable,
        DataTableToggleColumns
    },

    data: () => ({
        card1: true,
        card2: true,
        form: true,
        card_id: null,

        postcodes: [],
        gender: [],
        memberTypes: [],
        classificationTypes: [],
        years: [],
        membershipFees: [],

        activeMembers: false,
        membershipFeePayments: false,
        total_amount: 0.0,

        payment_start_date: null,
        payment_end_date:null,
        payment_start_date_formatted: null,
        payment_end_date_formatted: null,
        payment_start_date_menu: false,
        payment_end_date_menu:false,

        payer: null,
        member: null,
        invoice_nr: null,
        search_query: null,
        searchTimer: null,

        selectedPostcodes: [],
        selectedGender: [],
        selectedMemberTypes: [],
        selectedClassificationTypes: [],
        selectedMembershipFeePaymentYears: [],
        selectedMembershipFees: [],

        dataTableSettings: {
            id: 'dtEvents',
            title: 'Seznam plačanih članarin',
            sortColumn: ['id'],
            sortDirection: ['desc'],
            progressHeight: 4,
            headers: [
                { text: "ID", value: "id", class: "text-xs-left", visibility: true},
                { text: "Št. plačila", value: "membership_fee_payment_id", class: "text-xs-left", visibility: true},
                { text: "Plačnik", value: "payer", class: "text-xs-left", visibility: true},
                { text: "Član", value: "member", class: "text-xs-left", visibility: true},
                { text: "Tip člana", value: "member.member_type", class: "text-xs-left", visibility: true},
                //{ text: "Vrsta člana", value: "member.member_classification", class: "text-xs-left", visibility: true},
                { text: "Članarina", value: "membership_fee", class: "text-xs-left", visibility: true},
                { text: "Leto", value: "membership_fee_year", class: "text-xs-left", visibility: true},
                { text: "Znesek", value: "amount", class: "text-xs-left", visibility: true},
                {text: "Datum plačila", value: "date_time_formatted", class: "text-xs-left", visibility: true},
                { text: "Upravljanje", value: "action", align: "right", class: "text-xs-right", sortable: false, visibility: true, permissions:[]},
            ],
            updateInterval: true,
            rowsPerPage: 10,
            endpoint: 'sobec/invoices',
            editItem: {
                route: null,
                routeParameterValue: 'uuid'
            },
            viewItem: {
                route: null,
                routeParameterValue: null
            },
            deleteItem: {
                vuexAction: 'DELETE_INVOICE',
                replaceStrWithColumnValue: 'id',
                confirmationText : "Sta prepričani da želite odstraniti članarino št. {str_to_replace} ?",
                dialogConfirmSuccessText: 'Članarina številka {str_to_replace} je bila uspešno odstranjena.',
                dialogConfirmFailText: 'Pri odstranjevanju članarine {str_to_replace} je prišlo do napake. Poskusite ponovno.'
            },

            toolbar: {
                buttons: {
                    refresh: true,
                    export: false,
                    addNew: true,
                    addNewRoute: 'add_membership_fee_payment',
                    toggleColumns: true
                }
            },

            eventBus: {
                refreshDataTable: 'refresh_dt_invoices',
                totalItems : {
                    event: ''
                },
                search: 'dt-rfid-invoices-search',
                toggleColumnsId: 'toggle-rfid-invoices-list-columns'
            }


        }
    }),

    watch: {
        payment_start_date(val) {
            this.payment_start_date_formatted = formatDate(val)
        },

        payment_end_date(val) {
            this.payment_end_date_formatted = formatDate(val)
        },

        payment_start_date_formatted(val) {
            if(val == null  || val == '') {
                this.payment_start_date = null
            }
        },

        payment_end_date_formatted(val) {
            if(val == null  || val == '') {
                this.payment_end_date = null
            }
        },

        searchFromStore(newValue) {
            this.search_query = newValue
            this.searchTotalAmount()
        }
    },

    computed: {
        columnBinding() {
            const binding = {}

            if (this.$vuetify.breakpoint.mdAndDown) binding.column = true

            return binding
        },

        queryParameters() {
            return {
                startDate: this.payment_start_date,
                endDate: this.payment_end_date,
                selectedYears: this.selectedMembershipFeePaymentYears,
                selectedMembershipFees: this.selectedMembershipFees,
                payerName: this.payer,
                memberName: this.member,
                invoiceNumber: this.invoice_nr,
                searchQuery: this.search_query
            }
        },

        checkboxMembershipFeePaymentLabel() {
            if(this.membershipFeePayments) {
                return 'DA'
            }

            return 'NE'
        },

        searchFromStore: {
           get() {
               return this.$store.getters.search
           },

           set(value) {
               this.$store.commit('SET_SEARCH', this.search_query)
           }
       }
    },

    methods: {
        checkApplicationPermissions(requiredPermissions) {
            return checkPermissions(requiredPermissions, getUserApplicationPermissions())
        },

        getTotalAmount(parameters) {
            this.$store.dispatch('INVOICE_TOTAL_AMOUNT', parameters)
            .then(response => {
                //window.console.log(response.data)
                this.total_amount = new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(response.data.total_amount);
            })
            .catch(err => {

            })
        },

        search() {
            var vm = this

            setTimeout(() => {
                EventBus.$emit(this.dataTableSettings.eventBus.refreshDataTable, 'pass-some-data');
            }, 250)

            //this.getTotalAmount(this.queryParameters);

            if(vm.searchTimer) {
                clearTimeout(vm.searchTimer)
                vm.searchTimer = null
            }

            vm.searchTimer = setTimeout(() => {
                vm.getTotalAmount(vm.queryParameters)
            }, 100)

            
        },

        searchTotalAmount() {
            var vm = this
            if(vm.searchTimer) {
                clearTimeout(vm.searchTimer)
                vm.searchTimer = null
            }

            vm.searchTimer = setTimeout(() => {
                vm.getTotalAmount(vm.queryParameters)
            }, 250)
        },

        exportData() {
            window.console.log("exporting data ...");
            let parameters = {
                startDate: this.payment_start_date,
                endDate: this.payment_end_date,
                selectedYears: this.selectedMembershipFeePaymentYears,
                selectedMembershipFees: this.selectedMembershipFees,
                payerName: this.payer,
                memberName: this.member,
                invoiceNumber: this.invoice_nr
            }
            
            addExportToQueue('membership-fee-payments', parameters);
        },

        displayResults() {
            setTimeout(() => {
                EventBus.$emit(this.dataTableSettings.eventBus.refreshDataTable, 'pass-some-data');
            }, 280)
        },

        dateMenuSave(parameter) {
            if(parameter == 'payment_start_date') {
                this.$refs.payment_start_date_menu.save(this.payment_start_date)
                this.payment_start_date_menu = false
            }

            if(parameter == 'payment_end_date') {
                this.$refs.payment_end_date_menu.save(this.payment_end_date)
                this.payment_end_date_menu = false
            }
        },

        clearPayer() {
            this.payer = null;
        },

        clearMember() {
            this.member = null
        },

        clearInvoiceNr() {
            this.invoice_nr = null
        }
    },
    
    created() {
        this.$store.dispatch('ROUTE_NAME', this.$route.name) 
        if(isMobileDevice(this)) {
            this.card1 = false
        }
    },

    mounted() {
        var vm = this
        vm.$store.commit('SET_PROGRESS', true)

        EventBus.$on(vm.dataTableSettings.eventBus.search, (data) => {
            window.console.log("x")
            vm.search_query = data
            if(vm.searchTimer) {
                clearTimeout(vm.searchTimer)
                vm.searchTimer = null
            }

            vm.searchTimer = setTimeout(() => {
                vm.getTotalAmount(vm.queryParameters)
            }, 100)
            
        })

        vm.$store.dispatch('PARAMETERS_DATA')
        .then(response => {
            //window.console.log(response.data)
            vm.memberTypes = response.data.memberTypes
            vm.classificationTypes = response.data.memberClassifications
            vm.years = response.data.years
            vm.membershipFees = response.data.membershipFees
        })
        .catch(error => {
            window.console.error("### ERROR MembershipFeePayments.vue@mounted ###");
            window.console.error(error)
        })
        .finally(() => {
            vm.$store.commit('SET_PROGRESS', false)
        })

        this.getTotalAmount(this.queryParameters)

    },

    beforeDestroy() {
        clearTimeout(this.searchTimer)
        EventBus.$off(this.dataTableSettings.id)
        EventBus.$off(this.dataTableSettings.eventBus.refreshDataTable)
        EventBus.$off(this.dataTableSettings.eventBus.search)
    }
}

</script>